import { findParentNodeOfType, isElementDomNode } from '@remirror/core';
import {
  defaultAbsolutePosition,
  hasStateChanged,
  isPositionVisible,
  Positioner,
} from '@remirror/extension-positioner';

export const codeBlockPositioner = Positioner.create({
  getActive(props) {
    const { selection, schema } = props.state;
    const parent = findParentNodeOfType({ selection, types: schema.nodes.codeBlock });
    if (!parent) return Positioner.EMPTY;
    return [parent];
  },

  getPosition(props) {
    const { data, view } = props;
    const node = view.nodeDOM(data.pos);

    if (!isElementDomNode(node)) return defaultAbsolutePosition;
    const rect = node.getBoundingClientRect();
    const editorRect = view.dom.getBoundingClientRect();
    const left = view.dom.scrollLeft + rect.left - editorRect.left;
    const top = view.dom.scrollTop + rect.top - editorRect.top;
    const visible = isPositionVisible(rect, view.dom);

    return { x: left - 1, y: top - 1, width: rect.width, height: rect.height, rect, visible };
  },

  hasChanged: hasStateChanged,
});

export default codeBlockPositioner;
